.x-axis-label {
    text-align: center;
    font-size: var(--font-small);
    color: var(--grey-lt);
    margin-top: -6px;
    padding-bottom: 16px;
}
